export const text = {
  Search: "검색",
  Show: "표시",
  entries: "항목",
  "Insert a new column before": "새 열을 앞에 삽입",
  "Insert a new column after": "새 열을 뒤에 삽입",
  "Delete selected columns": "선택한 열 삭제",
  "Delete selected rows": "선택한 행 삭제",
  "Rename this column": "열 이름 변경",
  "Column name": "열 이름",
  "Order ascending": "오름차순 정렬",
  "Order descending": "내림차순 정렬",
  "Insert a new row before": "새 행 앞에 삽입",
  "Insert a new row after": "새 행 뒤에 삽입",
  "Edit comments": "댓글 편집",
  "Add comments": "댓글 추가",
  Comments: "댓글",
  "Clear comments": "댓글 삭제",
  Copy: "복사",
  Paste: "붙여넣기",
  "Save as": "이름을 지정하여 저장",
  About: "정보",
  "Are you sure to delete the selected rows?": "선택한 행을 삭제하시겠습니까?",
  "Are you sure to delete the selected columns?":
    "선택한 열을 삭제하시겠습니까?",
  "No cells selected": "선택한 셀이 없습니다",
  "No records found": "데이터가 없습니다",
  "Showing page {0} of {1} entries": "{1}개 중 {0} 페이지를 표시",
  "Merge the selected cells": "선택한 셀 병합",
  "There is a conflict with another merged cell":
    "다른 병합된 셀과 충돌이 있습니다",
  "Invalid merged properties": "잘못된 병합 속성입니다.",
  "Cell already merged": "이미 병합된 셀입니다.",
  "This action will destroy any existing merged cells. Are you sure?":
    "병합된 셀이 삭제됩니다. 계속하시겠습니까?",
  "The merged cells will retain the value of the top-left cell only. Are you sure?":
    "셀을 병합하면 왼쪽 상단 셀의 값만 유지됩니다. 계속하시겠습니까?",
  "This action will clear your search results. Are you sure?":
    "검색 결과가 삭제됩니다. 계속하시겠습니까?",
};
